import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../components/Pagination";
import ReportTable from "../components/ReportTable";
import PageHeader from "../components/PageHeader";
import DateRangeFilter from "../components/DateRangeFilter";
import Loader from "../components/Loader";
import "../assets/css/shiftgroup.css";


import {
  attendanceStatusList,
  createStatus,
  updateStatus,
  deleteStatus,
  getAttendanceStatusById
} from "../redux/status/StatusActions";

import {
  selectAttendanceStatus,
  selectAttendanceStatusLoading,
  selectAttendanceStatusMeta,
  selectAttendanceStatusById
} from "../redux/status/StatusSelector";


function Status() {
  const dispatch = useDispatch();

  // const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dropdownOptions, setDropdownOptions] = useState([]);

  const fetchDropdownData = useCallback(async () => {
  const result = await dispatch(attendanceStatusList({}));

  if (attendanceStatusList.fulfilled.match(result)) {
    setDropdownOptions(result.payload.data.message || []);
  }
}, [dispatch]);



  const statusData = useSelector(selectAttendanceStatus);
     const attendanceStatusOptions = [
      {label: "All", value: ""},
      ...dropdownOptions.map(item => ({
        label: item.AttendanceStatus?. toUpperCase(),
        value:item.AttendanceStatus,
      })),
    ];

    const shortNameOptions = [
      {label: "All", value: ""},
      ...dropdownOptions.map(item => ({
        label: item.ShortName?. toUpperCase(),
        value:item.ShortName,
      })),
    ];
    const columns = [
  { key: "action", label: "Action" },


  // { key: "sno", label: "S.No" },
  { key: "attendanceStatus", label: "Attendance Status" , filterType: "select", filterOptions:attendanceStatusOptions,},
  { key: "shortName", label: "Short Name", filterType: "select",filterOptions:shortNameOptions  },
  {key: "status", label: "Status",filterType: "select",
    filterOptions: [
      {label: "All", value: ""},
      {label: "Active", value:1},
      {label: "Inactive", value:0}
    ]
  },
];

  const statusMeta = useSelector(selectAttendanceStatusMeta);
  const selectedStatus = useSelector(selectAttendanceStatusById);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [showAddModal, setShowAddModal] = useState(false);

  const [addFormData, setAddFormData] = useState({
    AttendanceStatus: "",
    ShortName: "",
    Status: true,
  });

  const [errors, setErrors] = useState({
    AttendanceStatus: "",
    ShortName: "",
  });
 const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);



  const[filters , setFilters] = useState({
    AttendanceStatus: "",
    ShortName: "",
    Status:"",
  });


  const handleHeaderFilterChange = useCallback((cf) => {
  
    const updatedFilters = {};
  
    if (cf.attendanceStatus?.value) {
      updatedFilters.AttendanceStatus = cf.attendanceStatus.value;
    }

    if(cf.shortName?.value) {
      updatedFilters.ShortName = cf.shortName.value;
    }

    if(cf.status?.value !== undefined && cf.status.value !== ""){
      updatedFilters.Status = Number(cf.status.value);
    }
    setFilters(updatedFilters);
    setCurrentPage(1);
  
  }, []);

  // const buildDropdownPayload = () => {
  //   return{};
  // }

  const buildFilterPayload = useCallback(() => {
  
    const payload = {
       PageNumber: currentPage,
    PageSize: pageSize,
    };
  
    Object.keys(filters).forEach((key) => {
  
      const value = filters[key];
  
      if(value !== "" && value !== undefined && value !== null){
  
        // if(typeof value === "string"){
        //   payload[key] = value.trim();
        // }
        // else{
        //   payload[key] = value;
        // }
  
        payload[key] = typeof value === "string" ? value.trim() :value;
  
      }
  
  
    });
     
  
  
  return payload;
  
  }, [filters, currentPage, pageSize]);
  

  useEffect(() => {
  fetchDropdownData();
}, [fetchDropdownData]);


useEffect(() => {
  const fetchData = async () => {
    setLoading(true);

    try {
      await dispatch(
        attendanceStatusList(
          buildFilterPayload()
        )
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const timer = setTimeout(fetchData, 400);

  return () => clearTimeout(timer);
}, [dispatch, currentPage, pageSize, filters]);

  const [formData, setFormData] = useState({
  AttendanceStatusCode: "",
  AttendanceStatus: "",
  ShortName: "",
  Status:true,
});


  const validateAttendanceStatus = (value) => {
  const status = value.trim();

  if (!status) {
    return "Attendance Status is required.";
  }

  if (status.length < 3) {
    return "Attendance Status must be at least 3 characters.";
  }

  if (status.length > 50) {
    return "Attendance Status cannot exceed 50 characters.";
  }

  if (!/^[A-Za-z ]+$/.test(status)) {
    return "Only letters and spaces are allowed.";
  }

  return "";
};

const validateShortName = (value) => {
  const shortName = value.trim();

  if (!shortName) {
    return "Short Name is required.";
  }

  if (shortName.length < 1) {
    return "Short Name is required.";
  }

  if (shortName.length > 5) {
    return "Short Name cannot exceed 5 characters.";
  }

 if (!/^[A-Za-z\s\/\\()_-]+$/.test(shortName)) {
  return "Only letters, spaces, /, \, -, (, ), and _ are allowed.";
}

  return "";
};
 const validate = () => {
  const attendanceError = validateAttendanceStatus(
    addFormData.AttendanceStatus
  );

  const shortNameError = validateShortName(
    addFormData.ShortName
  );

  setErrors({
    AttendanceStatus: attendanceError,
    ShortName: shortNameError,
  });

  return !attendanceError && !shortNameError;
};
const handleAddStatus = async () => {
  
  const attendanceError = validateAttendanceStatus(
    addFormData.AttendanceStatus
  );

  const shortNameError = validateShortName(
    addFormData.ShortName
  );

  setErrors({
    AttendanceStatus: attendanceError,
    ShortName: shortNameError,
  });


  if (attendanceError || shortNameError) {
    return;
  }
  setLoading(true)
  console.log("Loader ON");

  console.log(addFormData);
  
  await dispatch(createStatus(addFormData));

 await Promise.all([
    dispatch(attendanceStatusList(buildFilterPayload())),
    fetchDropdownData()
]);
  setShowAddModal(false);

  setAddFormData({
    AttendanceStatus: "",
    ShortName: "",
    Status:true,
  });

  setLoading(false)

}





const handleEdit = async (row) => {
  const result = await dispatch(
    getAttendanceStatusById({
      AttendanceStatusCode:row.id,
    })
  );

  if(getAttendanceStatusById.fulfilled.match(result)) {
    const data = result.payload.data;

  setFormData({
    AttendanceStatusCode:data.AttendanceStatusCode,
    AttendanceStatus:data.AttendanceStatus?.trim() || "",
    ShortName:data.ShortName?.trim() || "",
    Status:data.Status,

  })

  setErrors({
    AttendanceStatus: "",
    ShortName: "",
  })
  setShowModal(true)
}
  }


const handleUpdate = async () => {
  const attendanceError = validateAttendanceStatus(
    formData.AttendanceStatus
  );
  const shortNameError = validateShortName(
    formData.ShortName
  )
  setErrors({
    AttendanceStatus: attendanceError,
    ShortName: shortNameError,
  })
  if(attendanceError || shortNameError) {
    return
  }
  try{
  setLoading(true)
  await dispatch(updateStatus(formData));


await Promise.all([
    dispatch(attendanceStatusList(buildFilterPayload())),
    fetchDropdownData()
]);  setShowModal(false)
  }catch(error){
    console.log(error)
  }finally{
  setLoading(false)
}
}

// const openDeletePopup = async (row) =>{
//    console.log("Delete Row:", row);
//   setSelectedRow(row);
//   setShowDeleteModal(true);
// }

//   const handleDelete = async() =>{
      
//      const result =  await dispatch(
//       deleteStatus({
//         AttendanceStatusCode: selectedRow.id,
//         AttendanceStatus: selectedRow.attendanceStatus
//       })
//     );
//    if(deleteStatus.fulfilled.match(result)) {
//     setShowDeleteModal(false);
//  await Promise.all([
//         dispatch(attendanceStatusList(buildFilterPayload())),
//         fetchDropdownData()
//     ]);
//    }
//   };
  console.log("statusData:", statusData);

console.log("Is Array:", Array.isArray(statusData));
  const data =
    statusData?.map((item, index) => ({
      id: item.AttendanceStatusCode,
      sno: index + 1,
      attendanceStatus: item.AttendanceStatus?.toUpperCase() || "",

      shortName: item.ShortName.trim(),
     status: (
      <button 
      className={
        item.Status
        ? "status-btn active-status"
        : "status-btn inactive-status"
      }>
        {item.Status ? "ACTIVE" : "INACTIVE"}
      </button>
     )
    })) || [];

 

  return (
    <>
          {loading && <Loader isLoading={loading} />}

    <div className="status-page ">
      <PageHeader
        icon={<i className="bi bi-list-check"></i>}
        title="Attendance Status"
        subtitle="Manage Attendance Status"
        actions={
          <>

            <button
              className="add-shift-btn"
              onClick={() => {
                setErrors({
                  AttendanceStatus: "",
                  ShortName: "",
                });

                setAddFormData({
                  AttendanceStatus: "",
                  ShortName: "",
                  Status:true,
                });

                setShowAddModal(true);
              }}
            >
             + New
            </button>
          </>
        }
      />

      <div className="status-data">
        <div className="table-container">
        <ReportTable
          columns={columns}
          data={data}
          serverSide={true}
         stickyColumns={["action"]}
          onHeaderFilterChange={handleHeaderFilterChange}
          renderActions={(row) => (
            <div className="shift-action-buttons">
              <button
                className="action-btn edit-btn"
                onClick={() => handleEdit(row)}
              >
                <i className="bi bi-pencil-square"></i>
              </button>


              {/* <button
                className="action-btn delete-btn"
                onClick={() => openDeletePopup(row)}
              >
                <i className="bi bi-trash-fill"></i>
              </button> */}
            </div>
          )}
        />
        </div>
          <Pagination
          currentPage={currentPage}
          totalCount={statusMeta?.totalRecords || 0}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={(size) => {
            setPageSize(size);
            setCurrentPage(1);
          }}
        />
      </div>

    {showAddModal && (
  <div
    className="se-overlay"
    onClick={() => setShowAddModal(false)}
  >
    <div
      className="se-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="se-modal__header">
        <div>
          <h3>Add Attendance Status</h3>
          <p className="se-modal__subtitle">
            Create a new attendance status
          </p>
        </div>

        <button
          className="se-close"
          onClick={() => setShowAddModal(false)}
        >
          <i className="bi bi-x-lg"></i>
        </button>
      </div>

      <div className="se-modal__body">
        <section className="se-section">
          <h4 className="se-section__title">
            Attendance Status Details
          </h4>

          <div className="se-grid">

            <div className="se-field se-field--full">
              <label>Attendance Status</label>

              <input
                className={`se-input ${
                  errors.AttendanceStatus ? "se-input--error" : ""
                }`}
                type="text"
                placeholder="Enter Attendance Status"
                value={addFormData.AttendanceStatus}
                onChange={(e) => {
                  const value = e.target.value;

                  setAddFormData({
                    ...addFormData,
                    AttendanceStatus: value,
                  });

                  setErrors({
                    ...errors,
                    AttendanceStatus:
                      validateAttendanceStatus(value),
                  });
                }}
              />

              {errors.AttendanceStatus && (
                <p className="error-text">
                  {errors.AttendanceStatus}
                </p>
              )}
            </div>

            <div className="se-field">
              <label>Short Name</label>

              <input
                className={`se-input ${
                  errors.ShortName ? "se-input--error" : ""
                }`}
                type="text"
                placeholder="Enter Short Name"
                value={addFormData.ShortName}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();

                  setAddFormData({
                    ...addFormData,
                    ShortName: value,
                  });

                  setErrors({
                    ...errors,
                    ShortName: validateShortName(value),
                  });
                }}
              />

              {errors.ShortName && (
                <p className="error-text">
                  {errors.ShortName}
                </p>
              )}
            </div>

            <div className="se-field">
              <label>Status</label>
              <select className="se-input"
              value={addFormData.Status ? 1 : 0}
              onChange={(e) => 
                setAddFormData({
                  ...addFormData,
                    Status: Number(e.target.value) === 1,
                  
                })
            }>
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </div>

          </div>
        </section>
      </div>

      <div className="se-modal__footer">
        <button
          className="se-btn se-btn--ghost"
          onClick={() => setShowAddModal(false)}
        >
          Cancel
        </button>

        <button
          className="se-btn se-btn--primary"
          onClick={handleAddStatus}
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}

      {showModal && (
  <div
    className="se-overlay"
    onClick={() => setShowModal(false)}
  >
    <div
      className="se-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="se-modal__header">
        <div>
          <h3>Edit Attendance Status</h3>
          <p className="se-modal__subtitle">
            Update attendance status details
          </p>
        </div>

        <button
          className="se-close"
          onClick={() => setShowModal(false)}
        >
          <i className="bi bi-x-lg"></i>
        </button>
      </div>

      <div className="se-modal__body">
        <section className="se-section">
          <h4 className="se-section__title">
            Attendance Status Details
          </h4>

          <div className="se-grid">

            <div className="se-field se-field--full">
              <label>Attendance Status</label>

              <input
                className={`se-input ${
                  errors.AttendanceStatus
                    ? "se-input--error"
                    : ""
                }`}
                type="text"
                value={formData.AttendanceStatus}
                onChange={(e) => {
                  const value = e.target.value;

                  setFormData({
                    ...formData,
                    AttendanceStatus: value,
                  });

                  setErrors({
                    ...errors,
                    AttendanceStatus:
                      validateAttendanceStatus(value),
                  });
                }}
              />

              {errors.AttendanceStatus && (
                <p className="error-text">
                  {errors.AttendanceStatus}
                </p>
              )}
            </div>

            <div className="se-field">
              <label>Short Name</label>

              <input
                className={`se-input ${
                  errors.ShortName
                    ? "se-input--error"
                    : ""
                }`}
                type="text"
                value={formData.ShortName}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();

                  setFormData({
                    ...formData,
                    ShortName: value,
                  });

                  setErrors({
                    ...errors,
                    ShortName: validateShortName(value),
                  });
                }}
              />

              {errors.ShortName && (
                <p className="error-text">
                  {errors.ShortName}
                </p>
              )}
            </div>

            <div className="se-field">
  <label>Status</label>

  <select
    className="se-input"
    value={formData.Status ? 1 : 0}
    onChange={(e) =>
      setFormData({
        ...formData,
        Status: Number(e.target.value) === 1,
      })
    }
  >
    <option value={1}>Active</option>
    <option value={0}>Inactive</option>
  </select>
</div>

          </div>
          
        </section>
      </div>

      <div className="se-modal__footer">
        <button
          className="se-btn se-btn--ghost"
          onClick={() => setShowModal(false)}
        >
          Cancel
        </button>

        <button
          className="se-btn se-btn--primary"
          onClick={handleUpdate}
        >
          Update
        </button>
      </div>
    </div>
  </div>
)}


{/* {showDeleteModal && (
  <div className="shift-modal-overlay">
    <div className="shift-modal">
      <h3>Delete Attendance status</h3>

       <p>
        Are you sure you want to delete{" "}
        <strong>{selectedRow?.attendanceStatus}</strong>?
      </p>

      <div className="modal-buttons">
        <button className="update-btn"
        onClick={handleDelete}>Yes</button>

        <button className="cancel-btn"
        onClick={() =>{
          setShowDeleteModal(false);
          setSelectedRow(null);
        }}>No</button>
      </div>
    </div>
  </div>
)} */}
    </div>
    </>
  );

}
export default Status;